import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import {
  Grid,
  Checkbox,
  ListItemText,
  FormControlLabel,
  ButtonGroup,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";

import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import TuneIcon from "@mui/icons-material/Tune";

import { makeStyles } from "@material-ui/core/styles";

import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import WwDatePicker from "../../Components/Modal/WwDatePicker";
import Slide from "@mui/material/Slide";

import { joinByKeys, getClassNames } from "../../Js/Common";
import { getByMonth, currentMonth } from "../../Js/TimeAndDate";
import {
  getRolesBySiteUuid,
  getUsersByRoleId,
} from "../../Layouts/Users/Services";

import { grey } from "@mui/material/colors";
import { findIndex, map } from "lodash";

const ReportFilter = (props) => {
  // Redux state
  const containerRef = useRef();
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const styles = useStyles();

  // State
  const [modalVisible, setModalVisible] = useState(false);
  const [assignmentName, setAssignmentName] = useState(null);
  const [trainers, setTrainers] = useState([]);
  const [classes, setClasses] = useState([]);

  const [endMinDate, setEndMinDate] = useState(Date.now());
  const [errorStartDate, setErrorStartDate] = useState(null);
  const [errorEndDate, setErrorEndDate] = useState(null);

  const [selectedTrainers, setSelectedTrainers] = useState([]);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [commences, setCommences] = useState(null);
  const [expiries, setExpiries] = useState(null);

  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheckAllClasses, setIsCheckAllClasses] = useState(false);
  const [isResetAll, setIsResetAll] = useState(false);

  useEffect(() => {
    resetState();
    const initialRender = async () => {
      if (userInfo.rolesInfo.title.toLowerCase() != "trainer") {
        let resTrainer = await getTrainerRole();
        if (resTrainer) {
          let params = {
            query: {
              $select: ["uid", "name"],
              role_uid: resTrainer.uid,
              site_uuid: userInfo.site_uuid,
              status: true,
              $limit: -1,
            },
          };
          let resUsersData = await getUsersByRoleId(params);

          if (resUsersData.data.length > 0) {
            let trainerInfo = [];
            resUsersData.data.map((userData) => {
              delete userData.rolesInfo;
              let newUserData = {};
              newUserData.value = joinByKeys(
                userData.name,
                ["firstname", "lastname"],
                " "
              );
              newUserData.id = userData.uid;
              trainerInfo.push(newUserData);
            });
            setTrainers(trainerInfo);
          }
        }
      }
      let classes = await getClassNames(userInfo.site_uuid);
      if (classes.length == 0) {
        return;
      }
      setClasses(classes);
      return;
    };
    initialRender();
  }, []);

  const handleOpen = () => setModalVisible(true);
  const handleClose = () => setModalVisible(false);

  const getTrainerRole = async () => {
    let params = {
      query: {
        $select: ["uid", "title"],
        title: "Trainer",
        site_uuid: userInfo.site_uuid,
      },
    };
    let resRolesData = await getRolesBySiteUuid(params);
    return resRolesData.data[0];
  };

  // Date change
  const DateChange = (date, valid, err, field) => {
    if (valid) {
      if (field == "startdate") {
        let endMinTime = new Date(date);
        setCommences(date);
        setEndMinDate(endMinTime.getTime());
        setErrorStartDate(null);
      }
      if (field == "enddate") {
        setExpiries(date);
        setErrorEndDate(null);
      }
    } else {
      setTimeout(() => {
        if (field == "startdate") {
          setCommences(null);
          setErrorStartDate(err);
        }
        if (field == "enddate") {
          setExpiries(null);
          setErrorEndDate(err);
        }
      }, 500);
    }
  };

  const handleFilter = () => {
    let trainerUuids = [];
    if (userInfo.rolesInfo.title.toLowerCase() === "trainer") {
      trainerUuids.push(userInfo.uid);
    } else {
      trainerUuids = selectedTrainers.map((value) => value.id);
    }

    let classesUuids = selectedClasses.map((classobj) => classobj.id);
    props.press({
      assignmentName: assignmentName,
      selectedTrainers: trainerUuids,
      selectedClasses: classesUuids,
      start_date: commences,
      end_date: expiries,
    });
    handleClose();
  };

  // Select All trainers
  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    setSelectedTrainers(trainers.map((itemData) => itemData));
    if (isCheckAll) {
      setSelectedTrainers([]);
    }
  };

  // Add & Remove trainer from selection
  const handleSelectSingle = (itemData) => {
    let newArray = [...selectedTrainers];
    let fndIndx = findIndex(selectedTrainers, { id: itemData.id });
    if (fndIndx === -1) {
      newArray.push(itemData);
    } else {
      newArray.splice(fndIndx, 1);
    }
    setSelectedTrainers(newArray);
    if (newArray.length === trainers.length) {
      setIsCheckAll(true);
    } else {
      setIsCheckAll(false);
    }
  };

  // Select All classes
  const handleSelectAllClasses = (e) => {
    setIsCheckAllClasses(!isCheckAllClasses);
    setSelectedClasses(classes.map((itemData) => itemData));
    if (isCheckAllClasses) {
      setSelectedClasses([]);
    }
  };

  // Add & Removed classes from selection
  const handleSelectClasses = (itemData) => {
    let newArray = [...selectedClasses];
    let fndIndx = findIndex(selectedClasses, { id: itemData.id });
    if (fndIndx === -1) {
      newArray.push(itemData);
    } else {
      newArray.splice(fndIndx, 1);
    }

    setSelectedClasses(newArray);
    if (newArray.length === classes.length) {
      setIsCheckAllClasses(true);
    } else {
      setIsCheckAllClasses(false);
    }
  };

  const resetState = (clicked = false) => {
    setAssignmentName(null);
    setSelectedTrainers([]);
    setSelectedClasses([]);
    setCommences(null);
    setExpiries(null);
    setErrorStartDate(null);
    setErrorEndDate(null);
    if (clicked) {
      props.press({
        assignmentName: "",
        selectedTrainers: "",
        selectedClasses: "",
        start_date: "",
        end_date: "",
      });
    }
    handleClose();
  };

  return (
    <>
      <Button
        variant="contained"
        onClick={handleOpen}
        endIcon={<TuneIcon />}
        sx={{
          borderRadius: 10,
          fontWeight: "600",
          backgroundColor: "#F5F5F5",
          color: "primary.main",
          boxShadow: 0,
          textTransform: "inherit",
         
          "@media (min-width: 1636px)": { fontSize: "1.4rem" },
        }}
      >
        Filter
      </Button>
      <Modal
        open={modalVisible}
        onClose={handleClose}
        ref={containerRef}
        sx={{
          border: "0px !important",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Slide
          direction="up"
          in={modalVisible}
          container={containerRef.current}
        >
          <Box className={styles.Modal}>
            <Grid container style={{ gap: 1, justifyContent: "space-between" }}>
              <Grid item xs={12} sx={{ pr: 1, pl: 1 }}>
                <Typography
                  sx={{
                    color: "#FFFFFF",
                    fontWeight: "500",
                    "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                  }}
                >
                  {props.searchLabel ? props.searchLabel : "Assignment Name:"}
                </Typography>
                <TextField
                  fullWidth
                  InputProps={{
                    inputProps: {
                      style: {
                        padding: 10,
                        borderRadius: 5,
                        backgroundColor: "#FFFFFF",
                      },
                    },
                  }}
                  value={assignmentName}
                  onChange={(e) => {
                    setAssignmentName(e.target.value);
                  }}
                />
              </Grid>
            </Grid>
            <Grid container>
              {(userInfo.rolesInfo.title.toLowerCase() === "incharge" ||
                userInfo.rolesInfo.title.toLowerCase() === "admin" ||
                userInfo.rolesInfo.title.toLowerCase() === "staff") && (
                <>
                  <FormControlLabel
                    sx={{ ml: "0.2rem" }}
                    size="small"
                    control={
                      <Checkbox
                        checked={isCheckAll}
                        onChange={handleSelectAll}
                        sx={{
                          color: grey[200],
                          "&.Mui-checked": {
                            color: grey[200],
                          },
                          fontWeight: "500",
                          fontSize: "0.9rem",
                        }}
                      />
                    }
                    label="All Trainer"
                  />
                  <FormControl fullWidth sx={{ mx: 1, mb: 1 }} size="small">
                    {trainers && (
                      <Select
                        displayEmpty
                        multiple
                        value={selectedTrainers}
                        placeholder="Select Trainer"
                        sx={{
                          borderRadius: 2,
                          backgroundColor: "#F5F5F5",
                          padding: 0,
                        }}
                        renderValue={(selected) => {
                          return map(selected, "value").join(", ");
                        }}
                      >
                        {trainers.map((itemData, index) => (
                          <MenuItem
                            key={`${index}_Trainer`}
                            value={itemData}
                            onClick={() => handleSelectSingle(itemData)}
                          >
                            <Checkbox
                              checked={
                                selectedTrainers.filter(
                                  (item) => item.id === itemData.id
                                ).length > 0
                              }
                            />
                            <ListItemText primary={itemData.value} />
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  </FormControl>
                </>
              )}
              {(userInfo.rolesInfo.title.toLowerCase() === "trainer" ||
                userInfo.rolesInfo.title.toLowerCase() === "incharge" ||
                userInfo.rolesInfo.title.toLowerCase() === "admin" ||
                userInfo.rolesInfo.title.toLowerCase() === "staff") &&
                !props.classesHide && (
                  <>
                    <FormControlLabel
                      sx={{ ml: "0.2rem" }}
                      size="small"
                      control={
                        <Checkbox
                          checked={isCheckAllClasses}
                          onChange={handleSelectAllClasses}
                          sx={{
                            color: grey[200],
                            "&.Mui-checked": {
                              color: grey[200],
                            },
                            fontWeight: "500",
                            fontSize: "0.9rem",
                          }}
                        />
                      }
                      label="All Classes"
                    />
                    <FormControl fullWidth sx={{ mx: 1, mb: 1 }} size="small">
                      {classes && (
                        <Select
                          displayEmpty
                          multiple
                          value={selectedClasses}
                          placeholder="Select Classes"
                          sx={{
                            borderRadius: 2,
                            backgroundColor: "#F5F5F5",
                            padding: 0,
                          }}
                          renderValue={(selected) => {
                            return map(selected, "value").join(", ");
                          }}
                        >
                          {classes.map((itemData, index) => (
                            <MenuItem
                              key={`${index}_Classes`}
                              value={itemData}
                              onClick={() => {
                                handleSelectClasses(itemData);
                              }}
                            >
                              <Checkbox
                                checked={
                                  selectedClasses.filter(
                                    (item) => item.id === itemData.id
                                  ).length > 0
                                }
                              />
                              <ListItemText primary={itemData.value} />
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    </FormControl>
                  </>
                )}
            </Grid>
            <Grid container sx={{}}>
              <Grid item xs={6} sx={{ pr: 1 }}>
                <Typography
                  sx={{
                    fontWeight: "500",
                    fontSize: "0.9rem",
                    pl: 1,
                    "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                  }}
                >
                  Start Date
                </Typography>
                <WwDatePicker
                  dateChange={({ date, valid, errorMessage }) =>
                    DateChange(date, valid, errorMessage, "startdate")
                  }
                  maxDate={Date.now()}
                  defaultDate={commences}
                ></WwDatePicker>
              </Grid>
              <Grid item xs={6} sx={{ pr: 2 }}>
                <Typography
                  sx={{
                    fontWeight: "500",
                    fontSize: "0.9rem",
                    pl: 1,
                    "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                  }}
                >
                  End Date
                </Typography>
                <WwDatePicker
                  dateChange={({ date, valid, errorMessage }) =>
                    DateChange(date, valid, errorMessage, "enddate")
                  }
                  minDate={endMinDate}
                  defaultDate={expiries}
                ></WwDatePicker>
              </Grid>
              {errorStartDate && (
                <Grid>
                  <Typography className={styles.errorMessage}>
                    {errorStartDate}
                  </Typography>
                </Grid>
              )}
              {errorEndDate && (
                <Grid>
                  <Typography className={styles.errorMessage}>
                    {errorEndDate}
                  </Typography>
                </Grid>
              )}
            </Grid>
            <Box sx={{ my: 3, mx: 6 }}>
              <Button
                variant="standard"
                fullWidth
                sx={{
                  color: "#FFFFFF",
                  fontSize: "1rem",
                  fontWeight: "700",
                  border: 1,
                  borderColor: "#FFFFFF",
                  borderRadius: 10,
                  
                  "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                }}
                onClick={() => {
                  // if (
                  //   commences.toString() != "Invalid date" &&
                  //   expiries.toString() != "Invalid date"
                  // ) {
                    handleFilter();
                  // } else {
                  //   resetState(true);
                  // }
                }}
              >
                Apply
              </Button>
            </Box>
            <Box sx={{ mx: 6 }}>
              <Button
                variant="standard"
                fullWidth
                sx={{
                  color: "#FFFFFF",
                  fontSize: "1rem",
                  fontWeight: "700",
                  border: 1,
                  borderColor: "#FFFFFF",
                  borderRadius: 10,
                  
                  "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                }}
                onClick={() => {
                  resetState(true);
                }}
              >
                Reset
              </Button>
            </Box>
          </Box>
        </Slide>
      </Modal>
    </>
  );
};
const useStyles = makeStyles({
  Modal: {
    width: 400,
    backgroundColor: "#DB8829",
    boxShadow: 24,
    color: "#FFFFFF",
    borderRadius: 30,
    padding: 20,
  },
  errorMessage: {
    backgroundColor: "red",
    color: "#FFFFFF",
    borderRadius: 30,
    padding: "10px 20px",
  },
  textfield: {
    backgroundColor: "#FFFFFF",
    color: "#CCCCCC",
  },
});
export default ReportFilter;
